import React, { Component } from 'react';

class About extends Component {

componentDidMount(){
    document.body.className = "";
}

render() {
return (
<div>
    <div className="opis-zw" lang="pl-PL">
        <h1 className="nagl">Historia</h1>
        <p>Nasza przychodnia istnieje od 2001 roku. Na początku mieściliśmy się na ul. Rosy 36. Przez te
            lata cały czas staraliśmy się dostosowywać do potrzeb naszych klientów i (przede wszystkim) pacjentów.
            Zaczynaliśmy od jednego gabinetu, potem wygospodarowaliśmy salę operacyjną oraz małe pomieszczenie, gdzie
            zwierzaki dochodziły do siebie po operacjach. Jednak stale zwiększająca się liczba pacjentów skłoniła nas
            do poważniejszej inwestycji. Teraz możemy zaprosić Państwa oraz Państwa zwierzęta do siedziby przy ulicy
            Rolnej 103 w Kajetanach. Sami zaprojektowaliśmy przychodnię i dołożyliśmy starań, aby była ona wygodna i
            funkcjonalna, a także miła dla oka. W nowym budynku znajdują się dwa gabinety przyjęć, sala operacyjna,
            szpital do leczenia stacjonarnego, poczekalnia, salon piękności dla psich ślicznotek i przystojniaków
            (wanna do kąpieli oraz strzyżenie) oraz sklep.</p>

        <h1 className="nagl">Nasz zespół</h1>

        <div className="member">
           
                <img src="/assets/img/robert-flak.jpg" />
        
            
            <div className="info" lang="pl-PL">
            <h3>Robert Flak</h3>
            <h4>lekarz weterynarii, specjalista chirurgii weterynaryjnej</h4>
            <p>Studia na SGGW ukończył w 2000r., przez rok pracował w jednej z warszawskich lecznic dla
                małych zwierząt, a od 2001 roku prowadzi naszą przychodnię w Kajetanach.</p>
            
            </div>
            
        </div>

        <div className="member">
           
                <img src="/assets/img/agata-kam-fl.jpg" />
          

            <div className="info" lang="pl-PL">
            <h3>Agata Kamionka-Flak</h3>
            <h4>lekarz weterynarii, specjalista chorób koni</h4>
            <p>Studia na Warszawskiej SGGW ukończyła w 2000 roku. Od tego czasu zajmuje się leczeniem koni
                sportowych i rekreacyjnych, a w mniejszym stopniu także klaczy hodowlanych i źrebiąt. Od 2006 roku
                dodatkowo zajmuje się wykonywaniem gastroskopii u koni w szpitalu koni "Służewiec". W przychodni pomaga
                przy operacjach, zajmuje się leczeniem ran oraz okulistyką.</p>
            
            </div>

            
        </div>

        <div className="member">
           
                <img src="/assets/img/magda-pok-wojc.jpg" />
          

            <div className="info" lang="pl-PL">
            <h3>Magdalena Pokorska-Wójcik</h3>
            <h4>lekarz weterynarii</h4>
            <p>Studia weterynaryjne w Szkole Głównej Gospodarstwa Wiejskiego w Warszawie ukończyła w 2010
                roku. W pracy zajmuje się interną, z której pogłębia wiedzę podczas pracy klinicznej, licznych szkoleń
                i konferencji. Uzyskała specjalizację z dziedziny chorób psów i kotów, w pracy darzy szczególną troską
                i zainteresowaniem kocich pacjentów. Jej drugą pasją jest ultrasonografia, z zakresu której ukończyła
                specjalistyczne kursy i szkolenia oraz stale poszerza wiedzę. Interesuje się również radiologią oraz
                chorobami królików i małych gryzoni domowych. Prywatnie dumna mama dwojga urwisów i szczęśliwa
                posiadaczka kotki Plamki.</p>
            </div>
            
            
        </div>

        <div className="member">
           
                <img src="/assets/img/aleksandra-wojcik.jpg" />
         

            <div className="info" lang="pl-PL">
            <h3>Aleksandra Wójcik</h3>
            <h4>lekarz weterynarii</h4>
            <p>Absolwentka SGGW (2008r.). Od ukończenia studiów nieprzerwanie pracuje w zawodzie, od 2012
                roku udziela konsultacji kardiologicznych w lecznicach na terenie Warszawy, członek European Society of
                Veterinary Cardiologists.</p>
            </div>

            
        </div>

        <div className="member">

                <img src="/assets/img/agnieszka-ramm.jpg" />
        
            <div className="info" lang="pl-PL">
            <h3>Agnieszka Ramm</h3>
            <h4>lekarz weterynarii</h4>
            <p>Ukończyła studia na Wydziale Medycyny Weterynaryjnej SGGW w Warszawie. Interesuje się
                interną, chirurgią. Po pracy spędza czas z mężem i córkami. W wolnych chwilach biega i czyta książki.
                Jest właścicielką burej kotki Lenki.</p>
            </div>

        </div>

        <div className="member">

                <img src="/assets/img/iga-zielinska.jpg" />

          <div className="info" lang="pl-PL">
            <h3>Iga Zielińska</h3>
            <h4>lekarz weterynarii</h4>
            <p>Ukończyła studia na SGGW w Warszawie. Zajmuje się interną i anestezjologią. Miłośniczka
                muzyki filmowej i filmu, w wolnych chwilach haftuje oraz spędza czas ze swoimi zwierzakami - dwoma
                psami, Wallem i Martym, oraz koteczką Nalą.</p>
            </div>

        </div>

        <div className="member">

                <img src="/assets/img/malgorzata-krechowiecka.jpg" />

          <div className="info" lang="pl-PL">
            <h3>Małgorzata Krechowiecka</h3>
            <h4>lekarz weterynarii</h4>
            <p>W 2005r. ukończyła studia na wydziale medycyny weterynaryjnej na SGGW w Warszawie. W 2012r. ukończyła
             studia specjalizacyjne na SGGW uzyskując tytuł Specjalisty chorób psów i kotów, a w  2013r. uzyskała tytuł
              behawiorysty, kończąc Studium: “Kot – zachowania prawidłowe i zaburzenia behawioralne”. W pracy klinicznej
               zajmuje się interną, najchętniej dermatologią, chorobami endokrynologicznymi i zaburzeniami zachowania zwierząt. 
               Od lat regularnie uczestniczy w licznych szkoleniach, kongresach i konferencjach z Medycyny Weterynaryjnej. 
               Prywatnie mama  Mikołaja, miłośniczka żeglarstwa, salsy, narciarstwa i haluszków.</p>
            </div>

        </div>

        <div className="member">

                <img src="/assets/img/milena-maciejewska.jpg" />

          <div className="info" lang="pl-PL">
            <h3>Milena Maciejewska</h3>
            <h4>lekarz weterynarii</h4>
            <p>Ukończyła studia na Wydziale Medycyny Weterynaryjnej Uniwersytetu Przyrodniczego w Lublinie w 2013r. 
            Zajmuje się głównie interną, dermatologią oraz chirurgią miękka. 
            Zawodowe pasje rozwija przez udział w licznych konferencjach i warsztatach. 
            W wolnych chwilach uwielbia spędzać czas aktywnie z dala od miejskiego zgiełku, w otoczeniu przyrody. 
            Właścicielka energicznego i bardzo kreatywnego wyżła niemieckiego o imieniu Dara.</p>
            </div>

        </div>

        <div className="member">
            <img src="/assets/img/tomasz-kierebinski.jpg" />

            <div className="info" lang="pl-PL">
            <h3>Tomasz Kierebiński</h3>
            <h4>technik weterynarii</h4>
            <p>W roku 2008 ukończył czteroletnie technikum weterynaryjne i uzyskał stopień technika
                weterynarii. Od tego czasu uczęszczał na szkolenia z zakresu wiedzy zawodowej oraz pracował w sklepie
                zoologicznym, schronisku dla zwierząt i przychodni weterynaryjnej w Piotrkowie Trybunalskim. Jego
                zainteresowania obejmują odtwórstwo średniowieczne, gry bitewne i planszowe, oraz dobrą literaturę.
                Posiada uroczą szylkretową kotkę o imieniu Antonina von Paszkę.</p>
            </div>
        </div>

        <div className="member">
            <img src="/assets/img/sylwia-polanska.jpg" />

            <div className="info" lang="pl-PL">
            <h3>Sylwia Polańska</h3>
            <h4>technik weterynarii</h4>
            <p>Ukończyła dwuletnią szkołę policealną w zawodzie Technik Weterynarii. Bardzo lubi swoją pracę i kontakt z
            klientami naszej lecznicy. Ma w domu psy i koty, nie wyobraża sobie życia bez zwierząt. W wolnych chwilach 
            uwielbia jeździć do zaprzyjaźnionej stajni, żeby pojeździć konno, jest to jej pasją i odpoczynkiem od
             codzienności życia. Szczęśliwa żona, matka i babcia.</p>
            </div>
        </div>

    </div>
    </div>

    )
    }
    }
    export default About;